import { Step } from 'react-joyride';

const getBlacklistTourSteps = (isMobile: boolean): Step[] => {
  const suffix = isMobile ? '-mobile' : '-desktop';

  const allSteps: (Step & { desktopOnly?: boolean })[] = [
    {
      target: '.tour-title',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Bienvenido a <strong>Lista negra</strong>. Aquí bloqueas números de
          teléfono o correos para evitar que ciertas personas reserven citas en
          tu empresa (por ejemplo, tras repetidas ausencias sin avisar).
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-filter-input',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Usa este campo para <strong>buscar</strong> un teléfono o correo
          concreto dentro de la lista. Ignora los espacios, así que puedes
          escribir el número como quieras.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-add-btn',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa <strong>Añadir número</strong> para bloquear un nuevo teléfono o
          correo. Puedes indicar un <strong>motivo</strong> para recordar por
          qué lo bloqueaste.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '.tour-table-head',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Esta tabla muestra todos los registros bloqueados: teléfono, correo,
          motivo, fecha y si el bloqueo está activo.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
      desktopOnly: true,
    },
    {
      target: '.tour-activo-badge',
      content: (
        <div style={{ textAlign: 'justify' }}>
          <strong>Activo</strong> indica si el bloqueo está en vigor.
          <br />
          <br />
          <span style={{ color: '#10B981', fontWeight: 'bold' }}>✔ Sí</span>{' '}
          — esa persona no puede reservar.
          <br />
          <span style={{ color: '#EF4444', fontWeight: 'bold' }}>✘ No</span>{' '}
          — el bloqueo está desactivado, sin borrar el registro. Puedes
          reactivarlo cuando quieras editándolo.
        </div>
      ),
      placement: 'right',
      disableBeacon: true,
      desktopOnly: true,
    },
    {
      target: `.tour-edit-btn${suffix}`,
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa el <strong>lápiz </strong> para editar un registro: cambiar el
          teléfono, el correo, el motivo o activar/desactivar el bloqueo sin
          borrarlo.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: `.tour-delete-btn${suffix}`,
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa la <strong>papelera </strong> para eliminar un registro de la
          lista negra cuando ya no necesites mantener bloqueada a esa persona.
          Te pedirá confirmación.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '.tour-pagination',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Si tienes muchos registros, usa la <strong>paginación</strong> para
          moverte entre páginas y ajustar cuántos ver a la vez.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
    },
  ];

  return allSteps
    .filter((s) => !(isMobile && s.desktopOnly))
    .map(({ desktopOnly, ...step }) => step);
};

export default getBlacklistTourSteps;